import React, { useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import NavbarComponent from './NavbarComponent';
import Footer from './Footer';

const TermsPageE = () => {
  useEffect(() => {
    const hash = window.location.hash; // Extract hash from URL
    if (hash) {
      setTimeout(() => {
        const element = document.querySelector(hash);
        if (element) {
          requestAnimationFrame(() => {
            element.scrollIntoView({ behavior: 'smooth', block: 'start' });
          });

          // Fallback for elements near the bottom
          setTimeout(() => {
            window.scrollTo({ top: element.offsetTop, behavior: 'smooth' });
          }, 500);
        }
      }, 300); // Delay to ensure content is rendered
    }
  }, []);

  return (
    <>
      <NavbarComponent/>
      <Container className="my-4 terms-page">
          {/* Privacy Statement Section */}
          <section className="mb-4" id='s0'>
            <Row>
              <Col>
                <h2 className="terms-page-header">Privacy Statement</h2>
                {/* <p>Keep this a blank as of now and click on the link should not open anything.</p> */}
              </Col>
            </Row>
          </section>

          {/* Terms of Use Section */}
          <section className="mb-4" id='s1'>
            <Row>
              <Col>
                <h2 className="terms-page-header">Terms of Use</h2>
                <p>
                  By accessing and using this site, you agree to the following terms and conditions without limitation or qualification.
                </p>

                <h5 className="section-common-title">Compliance with Laws</h5>
                <p>
                  You are responsible for adhering to the laws applicable to your jurisdiction when accessing this site. Any information
                  you submit through this site will be treated as non-confidential and non-proprietary. You affirm that you possess the
                  legal right to submit such information.
                </p>

                <h5 className="section-common-title">Ownership of Content</h5>
                <p>
                  Unless otherwise specified, all content on this site, including text, images, and their arrangement, is owned by 720
                  Degrees and its affiliates. All trademarks referenced are the property of their respective owners.
                </p>

                <h5 className="section-common-title">License Restrictions</h5>
                <p>
                  Nothing on this site grants any license or right to any copyright, patent, trademark, or proprietary interest of 720
                  Degrees or any third party. The content—including graphic images, audio, video, HTML code, buttons, and text—may not be
                  copied, reproduced, republished, uploaded, posted, transmitted, or distributed without prior written consent from 720
                  Degrees. You may download and print one copy of materials for personal, non-commercial use only if you do not modify
                  them and retain all copyright and trademark notices.
                </p>

                <h5 className="section-common-title">Unauthorized Idea Submissions</h5>
                <p>
                  720 Degrees does not accept unsolicited idea submissions outside established business relationships. Any ideas shared
                  without a documented confidential relationship are considered non-confidential; 720 Degrees may develop or disclose
                  similar ideas without compensating you. Unauthorized submissions may be returned or destroyed at our discretion without
                  detailed review. By submitting ideas through this website, you agree to these terms.
                </p>

                <h5 className="section-common-title">Information Disclaimer</h5>
                <p>
                  The information provided on this site is offered free of charge for informational purposes only and does not create a
                  business or professional services relationship between you and 720 Degrees. Links to external sites are not
                  endorsements; 720 Degrees is not responsible for the content or services of those sites. Your use of information from
                  this site or linked sites is at your own risk.
                </p>

                <h5 className="section-common-title">Limitation of Liability</h5>
                <p>
                  This site and its contents are provided "as is." 720 Degrees makes no warranties regarding the site or any linked
                  services and expressly disclaims all implied warranties, including those of merchantability and fitness for a particular
                  purpose. Neither 720 Degrees nor its third-party service providers will be liable for any damages arising from your use
                  of this site or linked services.
                </p>

                <h5 className="section-common-title">Governing Law</h5>
                <p>
                  This site is maintained in AWS cloud. These terms are governed by the laws of São Paulo, Brazil. You acknowledge that 720
                  Degrees may choose the jurisdiction for any legal proceedings against it.
                </p>
              </Col>
            </Row>
          </section>

          {/* Responsible Disclosure Section */}
          <section className="mb-4" id='s2'> 
            <Row>
              <Col>
                <h2 className="terms-page-header">Responsible Disclosure</h2>
                <p>
                  At 720 Degrees, we prioritize the security of our applications and the data we manage. We appreciate any information that
                  can help us enhance our security posture.
                </p>
                <ul>
                  <li>
                    <strong>Safe Harbor:</strong> If you report a vulnerability using the outlined process and comply with these terms, we
                    will not pursue legal action against you for unauthorized access to identify the vulnerability.
                  </li>
                  <li>
                    <strong>Submission Process:</strong> Please send vulnerability reports to info@720Degrees.ai,including:-<br/>
                    - Description of the vulnerability<br/>
                    - Relevant URL, IP address, or other identifying information<br/>
                    - Steps to reproduce the issue (including logs or screenshots)<br/>
                    - How you discovered the issue<br/>
                    - Presumed impact<br/>
                    - Suggested remediation steps<br/>
                    - Your name and contact information
                  </li>
                  <li>
                    <strong>Scope:</strong> Do not access any individual workstations, systems, or networks belonging to third parties. The
                    safe harbor does not apply to such systems.
                  </li>
                  <li>
                    <strong>Methodology:</strong> Avoid denial of service attacks or any destructive methods. Cease testing once you
                    identify a vulnerability and report it as instructed.
                  </li>
                  <li>
                    <strong>Data Access:</strong> You must not access personal data of our customers or users. If you inadvertently acquire
                    such data, securely delete it.
                  </li>
                  <li>
                    <strong>Intellectual Property:</strong> By submitting a report, you grant us a perpetual license to use and disclose
                    the information provided for analysis and improvement purposes.
                  </li>
                  <li>
                    <strong>Liability Disclaimer:</strong> 720 Degrees is not liable for any damages related to your submission. All information submitted is provided without charge, and no fees will be paid for submissions.
                  </li>
                  <li>
                    <strong>Governing Law:</strong> These terms are governed by the laws of São Paulo, Brazil.
                    By participating in this program, you acknowledge and accept these terms. Thank you for helping us improve our security!
                  </li>
                </ul>
              </Col>
            </Row>
          </section>

          {/* Cookie Preferences Section */}
          <section className="mb-4" id='s3'>
            <Row>
              <Col>
                <h2 className="terms-page-header">Cookie Preferences</h2>
                <p>
                  We use cookies to provide better personalized services. You have the option of choosing to limit to essential cookies
                  only.
                </p>
              </Col>
            </Row>
          </section>

          {/* Site Map Section */}
          <section className="mb-4" id='s4'>
            <Row>
              <Col>
                <h2 className="terms-page-header">Site Map</h2>
                {/* <p>Technical Team has to build.</p> */}
              </Col>
            </Row>
          </section>
        </Container>
      <Footer/>
    </>
  );
};

export default TermsPageE;
